function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "c-check",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 14",
  id: "Ellipse_14",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  transform: "translate(2 2)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 14",
  id: "Ellipse_14",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  transform: "translate(2 2)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_132",
  "data-name": "Group 132"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M12,21.455l5.121,5.455L27.364,16",
  transform: "translate(-3.182 -4.954)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgCircleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.c3c39aaa.svg";
export { ForwardRef as ReactComponent };